import {EAdviceType} from './definitions';

export default {
  ednaAdvices: 'Советы edna',
  more: {
    [EAdviceType.WA_QUALITY_CHANNELS]: '<0>Смотреть больше рекомендаций</0>',
    [EAdviceType.WA_QUALITY_CHANNEL]: '<0>Смотреть больше рекомендаций</0>',
    [EAdviceType.WA_QUALITY_BROADCAST_SETTINGS]: '<0>Смотреть больше рекомендаций</0>',
    [EAdviceType.WA_QUALITY_BROADCAST_AUDIENCE]: '<0>Смотреть больше рекомендаций</0>',
    [EAdviceType.WA_QUALITY_TEMPLATE_TEXT]: '<0>Смотреть больше рекомендаций</0>',
    [EAdviceType.WA_QUALITY_TEMPLATE_BUTTONS]: '<0>Смотреть больше рекомендаций</0>',
    [EAdviceType.WA_CHANNEL_VERIFICATION]:
      'Чтобы подготовиться к верификации, ознакомьтесь <0>с нашим руководством.</0>',
    [EAdviceType.MAX_BLOCKING_PROTECTION]: '<0>Больше рекомендаций здесь</0>',
  },
  closeModal: {
    title: 'Скрыть совет навсегда?',
    subtitle:
      'Вы больше никогда не увидите этот совет здесь, но он останется доступен в документации',
  },
  description: {
    [EAdviceType.WA_CHANNEL_VERIFICATION]:
      'Верификация компании подтверждает, что ваша компания является законной и зарегистрированной. После верификации вам станут доступны расширенные функции WhatsApp:',
  },
  title: {
    [EAdviceType.WA_QUALITY_CHANNELS]: 'Как избежать блокировки канала WhatsApp',
    [EAdviceType.WA_QUALITY_CHANNEL]: 'Как поддерживать высокое качество и лимиты канала WhatsApp',
    [EAdviceType.WA_QUALITY_BROADCAST_SETTINGS]:
      'Как создать рассылку, чтобы избежать блокировки канала WhatsApp',
    [EAdviceType.WA_QUALITY_BROADCAST_AUDIENCE]:
      'Как создать рассылку, чтобы избежать блокировки канала WhatsApp',
    [EAdviceType.WA_QUALITY_TEMPLATE_TEXT]:
      'Как создать шаблон, чтобы избежать блокировки канала WhatsApp',
    [EAdviceType.WA_QUALITY_TEMPLATE_BUTTONS]:
      'Как создать шаблон, чтобы избежать блокировки канала WhatsApp',
    [EAdviceType.WA_CHANNEL_VERIFICATION]: 'Зачем нужна верификация бизнеса',
    [EAdviceType.MAX_BLOCKING_PROTECTION]:
      'Как сделать MAX доверенным каналом и избежать блокировок',
  },
  points: {
    [EAdviceType.WA_QUALITY_CHANNELS]: [
      'Используйте номера, давно зарегистрированные в WhatsApp — чем «старше» номер, тем ниже риск блокировки.',
      'Не начинайте рассылку с нового номера раньше, чем через сутки после регистрации. В первые 10 дней ограничьте количество новых контактов — не более 20 в сутки.',
      'Поддерживайте высокий процент входящих сообщений — старайтесь, чтобы хотя бы 30% получателей отвечали. Добавляйте вопросы, чтобы стимулировать отклик.',
    ],
    [EAdviceType.WA_QUALITY_CHANNEL]: [
      'Стремитесь к высокому показателю прочтения сообщений — не ниже 65%.',
      'Если нет уверенности в том, что у получателей есть WhatsApp-номер вашей компании, отправляйте рассылку частями — на 10–15% контактов от общей базы раз в час.',
      'Отправляйте не менее половины от текущего лимита шаблонных сообщений в течение 7 дней, чтобы сохранить или увеличить лимит.',
      'При снижении лимита распределите нагрузку между несколькими WhatsApp-аккаунтами, чтобы снизить риски дальнейших ограничений.',
    ],
    [EAdviceType.WA_QUALITY_BROADCAST_SETTINGS]: [
      'Не запускайте массовые рассылки сразу после подключения номера. Увеличивайте объём сообщений постепенно в течение первых недель.',
      'Отправляйте сообщения в подходящее время — избегайте ночных часов и раннего утра в выходные.',
      'Избегайте высокой частоты отправки: не чаще 1 сообщения в минуту и не более 8 часов подряд.',
    ],
    [EAdviceType.WA_QUALITY_BROADCAST_AUDIENCE]: [
      'Выбирайте целевые, релевантные аудитории. Избегайте случайных списков контактов.',
      'Персонализируйте сообщения: обращайтесь по имени, делайте индивидуальные предложения или добавляйте детали.',
      'Отправляйте сообщения только тем получателям, которые выразили согласие на их получение.',
      'Сначала протестируйте рассылку на 50–150 контактах перед массовым запуском.',
    ],
    [EAdviceType.WA_QUALITY_TEMPLATE_TEXT]: [
      'Делайте сообщения короткими и информативными, избегайте длинных текстов.',
      'Составляйте качественные шаблоны с ясным и релевантным контентом. Используйте ключевые слова.',
      'Добавляйте персонализацию (имя получателя) и чётко указывайте, почему получатель получил это сообщение.',
      'Следите за корректным отображением переменных (имён, дат, названий товаров и др.).',
    ],
    [EAdviceType.WA_QUALITY_TEMPLATE_BUTTONS]: [
      'Предусмотрите удобную возможность отписки (например, кнопки «Стоп» или «Отписаться»).',
      'Добавляйте интерактивные элементы — кнопки, эмодзи, ссылки.',
      'Тестируйте новые шаблоны на небольшой аудитории перед массовой рассылкой. Можно регистрировать и использовать тестовые каналы.',
    ],
    [EAdviceType.WA_CHANNEL_VERIFICATION]: [
      'Более высокие лимиты сообщений для всех каналов WhatsApp',
      'Отображение названия вашей компании вместо номера телефона',
      'Возможность запросить официальный значок верификации (зелёная галочка)',
    ],
    [EAdviceType.MAX_BLOCKING_PROTECTION]: [
      'Чтобы ваш аккаунт не заблокировали, избегайте массовых рассылок. Новые номера могут быть заблокированы, если отправлять более 15 сообщений в сутки на новые номера.',
      'Нельзя сразу запускать массовую рассылку с нового номера. Базу контактов нужно наращивать постепенно.',
      'Рассылка абсолютно одинакового текста по всей базе - прямой путь к автоматической блокировке.',
    ],
  },
};
